import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 1px 0px #E5E5E5',
    boxSizing: 'border-box',
    marginBottom: '5px',
    minHeight: '48px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      minHeight: 'auto'
    }
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '140px',
    height: '100%',
    borderRight: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    color: '#59758B',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      borderRight: 'none',
      borderBottom: '1px solid #E2EBF6',
      justifyContent:'center'
    }
  },
  toolbarTitle: {
    padding: '12px 30px',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '24px',
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 20px',
      fontSize: '16px'
    }
  },
  customTabRoot: {
    color: '#335267',
    padding: '12px 17px',
    borderBottom: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    fontSize: '13px',
    minWidth: '84px!important',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 15px',
      fontSize: '12px',
      overflowX: 'auto',  
      display: 'flex', 

    }
  },
  toolbarSwitchers: {
    flexDirection: 'row',
    Width: '540px',
    [theme.breakpoints.down('sm')]: { 
        width: '100%', 
        justifyContent: 'center',
        // flexDirection: 'row',
    }
  },
  tabsRoot: {
    flex: '1 1 auto',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
   
  },
  tabs: {
    flex: '0 1 220px',
    [theme.breakpoints.down('sm')]: {
      flex: '0 1 auto'
    }
  },
  // customTabWrapper: {
  //   alignItems: 'flex-start'
  // },
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  selected: {
    backgroundColor: '#E2F5F8',
    fontWeight: 'bold'
  },
  loaderWrapper: {
    position: 'fixed'
  },
  loaderClassName: {
    width: '80px !important',
    height: '80px !important'
  },
  tab: {
    maxWidth: '600px'
  }
}));

export default useStyles;
